import type { ReactNode } from "react";
import { Link } from "@tanstack/react-router";
import { cn } from "frontend-components";
import type { SurveyTableRow } from "./types";

type SurveyLinkProps = {
    survey: SurveyTableRow;
    customerId: string;
    children?: ReactNode;
    className?: string;
};

export default function SurveyLink({ survey, customerId, children, className }: SurveyLinkProps) {
    return (
        <Link
            to={
                survey.status === "DRAFT"
                    ? "/$customerId/pulse/$pulseId/surveys/$surveyId/edit"
                    : "/$customerId/pulse/$pulseId/surveys/$surveyId"
            }
            params={{
                customerId,
                pulseId: String(survey.pulseInstanceId),
                surveyId: String(survey.id),
            }}
            className={cn("hover:underline", className)}
        >
            {children ?? survey.title}
        </Link>
    );
}
